export function RematchButton({
  roundId,
  onClose,
  compact = false,
}: {
  roundId: string;
  onClose?: (() => void) | undefined;
  compact?: boolean;
}): React.JSX.Element {
  return (
    <button
      type="button"
      className="fr-btn"
      data-variant={compact ? "link" : "gold"}
      data-size={compact ? "sm" : "block"}
      onClick={() => {
        onClose?.();
        window.history.pushState(
          null,
          "",
          `/tee-off?rematch=${encodeURIComponent(roundId)}`,
        );
        window.dispatchEvent(new PopStateEvent("popstate"));
        window.scrollTo({ top: 0, behavior: "instant" });
      }}
    >
      {compact ? "Play again" : "Play again · Rematch"}
    </button>
  );
}
